import { api } from '../../api';

export interface RestaurantBulletin {
  description: string;
  endDate: string | null;
  id: string;
  name: string;
  repeat: string[];
  startDate: string;
}
export interface NewRestaurantBulletin {
  description: string;
  endDate: string | null;
  name: string;
  repeat: string[];
  startDate: string;
}

export const getRestaurantBulletins = (
  restaurantId: string,
): Promise<RestaurantBulletin[]> =>
  api.get(`/restaurants/${restaurantId}/restaurant-bulletins`);

export const createRestaurantBulletin = async (
  restaurantId: string,
  newRestaurantBulletin: NewRestaurantBulletin,
): Promise<void> =>
  api.post(
    `/restaurants/${restaurantId}/restaurant-bulletins`,
    newRestaurantBulletin,
  );

export const deleteRestaurantBulletin = async ({
  restaurantId,
  restaurantBulletinId,
}: {
  restaurantId: string | undefined;
  restaurantBulletinId: string | undefined;
}): Promise<void> =>
  api.delete(
    `/restaurants/${restaurantId}/restaurant-bulletins/${restaurantBulletinId}`,
  );

export const editRestaurantBulletin = async (
  restaurantId: string,
  bulletin: RestaurantBulletin,
): Promise<void> =>
  api.put(`/restaurants/${restaurantId}/restaurant-bulletins`, bulletin);
